import { User, Bell, Globe } from 'lucide-react'
import { useI18n } from '@/i18n'
import { useAuthStore } from '@/stores/authStore'

export function Header() {
  const { language, setLanguage, t } = useI18n()
  const user = useAuthStore((state) => state.user)

  const toggleLanguage = () => {
    setLanguage(language === 'zh' ? 'en' : 'zh')
  }

  return (
    <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-6">
      {/* Page Title - Will be updated by each page */}
      <div>
        <h2 className="text-lg font-semibold text-gray-800">{t('common.appTitle')}</h2>
      </div>

      {/* Right Side - User Info */}
      <div className="flex items-center gap-4">
        {/* Language Switcher */}
        <button
          onClick={toggleLanguage}
          className="flex items-center gap-1.5 px-2.5 py-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors text-sm font-medium"
          title={language === 'zh' ? 'Switch to English' : '切换到中文'}
        >
          <Globe className="w-4 h-4" />
          <span>{language === 'zh' ? '中文' : 'EN'}</span>
        </button>

        {/* Notifications */}
        <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors">
          <Bell className="w-5 h-5" />
        </button>

        {/* User Menu */}
        <div className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 cursor-pointer transition-colors">
          <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
            <User className="w-5 h-5 text-primary-600" />
          </div>
          <div className="text-sm">
            <p className="font-medium text-gray-800">
              {user?.username || user?.email || t('common.admin')}
            </p>
          </div>
        </div>
      </div>
    </header>
  )
}
